import getIterableElements from "../../utils/get-iterable-elements";

/**
 *
 * @param {TorusClassNamesProps} name
 * @param {any} module
 * @param {Array<TorusElement> | Set<TorusElement> | null} targets
 * @param {Object | null | undefined} options
 * @param {String} attribute
 * @returns {Array<MainClassProps>}
 */
const staticInit = (name, module, targets, options, attribute) => {
  const elements = getIterableElements(
    targets || document.querySelectorAll(`[data-${attribute}]`)
  );

  if (!elements?.length) {
    return [];
  }

  const promises = [];

  for (const target of elements) {
    if (target?.Torus?.[name]) {
      continue;
    }

    target.Torus = target.Torus || {};

    const initialized = new module(target).init(options);

    if (initialized) {
      target.Torus[name] = initialized;

      promises.push(initialized);
    }
  }

  return promises;
};

export default staticInit;
